import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NormallyOpenedClosed } from '../../../projects/client';

@Pipe({
  name: 'translateValveType',
})
export class TranslateValveTypePipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(value: string): string {
    if (value === NormallyOpenedClosed.normallyOpened) {
      return this.translateService.instant('+INSTALLATIONS.SRC.FHT_CHANNEL.VALVE_TYPE_OPEN');
    } else if (value === NormallyOpenedClosed.normallyClosed) {
      return this.translateService.instant('+INSTALLATIONS.SRC.FHT_CHANNEL.VALVE_TYPE_CLOSED');
    } else {
      return '-';
    }
  }
}
